export const enumPermisosRecaudoGenerico = Object.freeze({
  RECAUDO_GENERICO: 50000,
  DEBOLUCION_RECAUDO_GENERICO: 50001,
  BOTON_PORTAL_PAGOS: 50002,
  GENERACION_QR_PORTAL_PAGOS: 50003,
});